<template>
  <div>
    <router-link
      v-if="menu.parent.isShow && menu.parent.href"
      :to="menu.parent.href"
      :class="{ 'div--active': ishrefEqualToRoute(menu.parent.href) }"
      exact-path
      class="div--menu"
      tag="div">
      <a class="a--none color--white">
        <div class="sidemenu-container">
          <img
            :src="require(`@/assets/icon-sidebar/${menu.parent.icon}.svg`)"
            height="25">
          <span
            v-if="minimized"
            class="nav-text toggleable">  {{ menu.parent.name }} </span>
        </div>
      </a>
    </router-link>
    <div
      v-else-if="menu.parent.isShow && menu.parent.hrefout"
      :class="{ 'div--active': ishrefoutEqualToWindowLocation(menu.parent.hrefout) }">
      <a
        :href="menu.parent.hrefout"
        class="a--none color--white">
        <div class="sidemenu-container">
          <img
            :src="require(`@/assets/icon-sidebar/${menu.parent.icon}.svg`)"
            height="25">
          <span
            v-if="minimized"
            class="nav-text toggleable">  {{ menu.parent.name }} </span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved,vue/require-default-prop */
/* eslint linebreak-style: ["error", "windows"] */

export default {
  /**
   * Created by Gumilar Sidiq Saputra - gumilar@jojonomic.com
   * Last update 17 Juni 2021
   *
   * Nested Menu Component contains Nested Menu Unit Component.
   */
  name: 'JNestedMenuOos',
  components: {
  },
  /**
   * menu: object contains nested menu details
   */
  props: {
    menu: null,
    minimized: true,
  },
  data() {
    return {
      showCollapse: null,
    };
  },
  /**
    * getArrowIcon: get arrow icon is open or close
    * getCollapseId: get collapse id
    * getCollapseName: get collapse name
    * getMenuIcon: get menu icon
    */
  computed: {
    getArrowIcon() {
      if (!this.showCollapse) return 'fa fa-angle-right icon--right icon';
      return 'fa fa-angle-right icon--right icon open';
    },
    getCollapseId() {
      return `#collapse${this.menu.parent.name}`;
    },
    getCollapseName() {
      return `collapse${this.menu.parent.name}`;
    },
    getMenuIcon() {
      return `fa fa-${this.menu.parent.icon} left-icon`;
    },
    getMenuIcon2() {
      return `fa fa-${this.menu.parent.icon} color--white left-icon`;
    },
  },
  mounted() {
    if (this.menu.child !== undefined) {
      this.menu.child.forEach((e) => {
        if (e.href === this.$route.fullPath) {
          this.showCollapse = true;
        }
      });
    }
  },
  /**
   * negateIsCollapse: negate show collapse
   */
  methods: {
    ishrefEqualToRoute(href) {
      const route = this.$route.path.split('/')[1];
      // if (route.includes('experience-manager')) route = 'form-ui';
      return route.includes(href.split('/')[1]);
    },
    ishrefoutEqualToWindowLocation(hrefout) {
      const route = window.location.href;
      // if (route.includes('experience-manager')) route = 'form-ui';
      return route.includes(hrefout);
    },
    negateIsCollapse() {
      this.showCollapse = !this.showCollapse;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sidebar/jNestedMenu.vue